const dropdown = document.querySelector('.sub-navigation__dropdown');
const expandDropdown = elem => elem.classList.toggle('is-open');

const handleDropdownItemClick = parent => {
	event.preventDefault();
	parent.classList.remove('is-open');
	Array.from(parent.querySelectorAll('.sub-navigation__dropdown-item')).forEach(item => {
		item.classList.remove('selected');
	});
	event.target.parentNode.classList.add('selected');
	window.location = event.target.href;
};

Array.from(dropdown.querySelectorAll('.sub-navigation__dropdown-expand')).forEach(
	dropdownExpand => {
		dropdownExpand.addEventListener('mousedown', () => expandDropdown(dropdown));
	}
);

Array.from(dropdown.querySelectorAll('.sub-navigation__link')).forEach(dropdownItem => {
	dropdownItem.addEventListener('mousedown', () => handleDropdownItemClick(dropdown));
});

const removeRedundantSubnavs = () => {
	Array.from(document.querySelectorAll('.sub-navigation')).forEach((subnav, index) => {
		if (index > 0) subnav.parentNode.removeChild(subnav);
	});
};

removeRedundantSubnavs();

const toggleFixSubnav = () => {
	const subnav = document.querySelector('.sub-navigation');
	if (
		window.pageYOffset >
		document.querySelector('.sub-navigation').offsetTop -
			document.querySelector('.header-bottom').clientHeight
	) {
		subnav.classList.add('is-fixed');
	} else {
		subnav.classList.remove('is-fixed');
	}
};

window.addEventListener('scroll', () => toggleFixSubnav());
